import * as commander from 'commander'

import { connectCommand } from './connect'
import { infoCommand } from './info'
import { listCommand } from './list'
import { killCommand } from './kill'
import { pauseCommand } from './pause'
import { resumeCommand } from './resume'
import { createCommand } from './create'
import { logsCommand } from './logs'
import { metricsCommand } from './metrics'
import { execCommand } from './exec'
import { snapshotCommand } from './snapshot'

export const sandboxCommand = new commander.Command('sandbox')
  .description('work with sandboxes')
  .alias('sbx')
  .enablePositionalOptions()
  .addCommand(connectCommand)
  .addCommand(infoCommand)
  .addCommand(listCommand)
  .addCommand(killCommand)
  .addCommand(pauseCommand)
  .addCommand(resumeCommand)
  .addCommand(createCommand('create', 'cr'))
  .addCommand(logsCommand)
  .addCommand(metricsCommand)
  .addCommand(execCommand)
  .addCommand(snapshotCommand)
